import { documentReady, ErrorHandling } from '@omq/shared';
import { createHelpInfo } from './src/index';

import { DSN } from './src/error/sentry';

// create help-info module after document is ready
documentReady().then(() => {
  try {
    createHelpInfo();
  } catch (error) {
    // catch unhandled errors from application
    ErrorHandling.captureException(error, null, DSN);
  }
});
